import { SmartCaptcha } from '@yandex/smart-captcha';
import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Turnstile from 'react-turnstile';
import { usePlatformSettings } from '@shared/hooks';
import * as st from './styles.module.scss';

type PT = {
  onChange: (token?: string) => void;
  className?: string;
  tabIndex?: number;
  size?: 'normal' | 'compact';
};

export const Captcha = ({ size = 'normal', className, onChange }: PT) => {
  const {
    grecaptcha_enabled,
    cf_turnstile_enabled,
    yandex_captcha_enabled,
    grecaptcha_public_key,
    cf_turnstile_public_key,
    yandex_captcha_public_key,
  } = usePlatformSettings();

  const [type, setType] = useState<'google' | 'yandex' | 'cloudflare' | undefined>(undefined);

  const onExpired = () => onChange('');

  const onVerified = (token?: string | null) => token && onChange(token);

  useEffect(() => {
    onChange(
      grecaptcha_enabled || cf_turnstile_enabled || yandex_captcha_enabled ? '' : 'captchaDisabled'
    );
    if (grecaptcha_enabled) {
      setType('google');
      return;
    }
    if (cf_turnstile_enabled) {
      setType('cloudflare');
      return;
    }
    if (yandex_captcha_enabled) {
      setType('yandex');
      return;
    }
  }, [grecaptcha_enabled, cf_turnstile_enabled, yandex_captcha_enabled]);

  return (
    <div className={cn(st.captcha, className)}>
      {type === 'google' && grecaptcha_public_key && (
        <ReCAPTCHA
          onExpired={onExpired}
          size={size}
          onChange={onVerified}
          sitekey={grecaptcha_public_key}
        />
      )}

      {type === 'cloudflare' && cf_turnstile_public_key && (
        <Turnstile
          onExpire={onExpired}
          size={size}
          onVerify={onVerified}
          sitekey={cf_turnstile_public_key}
        />
      )}

      {type === 'yandex' && yandex_captcha_public_key && (
        <SmartCaptcha
          sitekey={yandex_captcha_public_key}
          onSuccess={onVerified}
          onTokenExpired={onExpired}
        />
      )}
    </div>
  );
};
